import React from 'react';
import Const from 'constants';
import {LineupPlayerFinalHead} from 'components/organisms/lineup/components/desktop/lineup-details/component/lineup-player-final-head';

export const Factory = {
    getContent(sportConfig, lineup) {
        if (Const.GAME_TYPE_TIERS === sportConfig.getGameType()) {
            if (inArray(sportConfig.getSport(), [Const.LEAGUE_GOLF, Const.LEAGUE_NFL])) {
                return (
                    <ul className="info-list">
                        <li>
                            <strong>Proj:</strong> {lineup.totalAdminPoints}
                        </li>
                        <li>
                            <strong>FPts:</strong> {lineup.totalLineupPoints}
                        </li>
                        <LineupPlayerFinalHead lineup={lineup} />
                        <li>
                            <strong>Total pOwn:</strong> {lineup.totalProjOwn}%
                        </li>
                    </ul>
                );
            }

            return (
                <ul className="info-list">
                    <li>
                        <strong>Proj:</strong> {lineup.totalAdminPoints}
                    </li>
                    <li>
                        <strong>FPts:</strong> {lineup.totalLineupPoints}
                    </li>
                    <LineupPlayerFinalHead lineup={lineup} />
                </ul>
            );
        } else if (this.hasTotalProjOwn(sportConfig)) {
            return (
                <ul className="info-list">
                    <li>
                        <strong>Proj:</strong> {lineup.totalAdminPoints}
                    </li>
                    <li>
                        <strong>FPts:</strong> {lineup.totalLineupPoints}
                    </li>
                    <LineupPlayerFinalHead lineup={lineup} />
                    <li>
                        <strong>Salary:</strong> {lineup.totalSalary}
                    </li>
                    <li>
                        <strong>Total pOwn:</strong> {lineup.totalProjOwn}%
                    </li>
                </ul>
            );
        }

        return (
            <ul className="info-list">
                <li>
                    <strong>Proj:</strong> {lineup.totalAdminPoints}
                </li>
                <li>
                    <strong>FPts:</strong> {lineup.totalLineupPoints}
                </li>
                <LineupPlayerFinalHead lineup={lineup} />
                <li>
                    <strong>Salary:</strong> {lineup.totalSalary}
                </li>
            </ul>
        );
    },
    hasTotalProjOwn(sportConfig) {
        const isTotalProjOwnAbsent =
            (inArray(sportConfig.getSport(), [Const.LEAGUE_LOL]) && sportConfig.isGameTypeClassic()) ||
            inArray(sportConfig.getSport(), [Const.LEAGUE_F1]) ||
            (inArray(sportConfig.getSport(), [Const.LEAGUE_CFB, Const.LEAGUE_NHL]) && sportConfig.isGameTypeShowDownOrSingleGame());

        return !isTotalProjOwnAbsent;
    },
};
